import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { Observable } from 'rxjs';
import { DealsAutocompleteComponent } from './deals-autocomplete.components';
import { Deals } from '../../domain/pmp-deals.model';
import { ActiveInactiveArchivedColorMap } from '../../enums/active-inactive-archived.enum';
import { PmpDealsService } from '../../services/pmp-deals.service';

@Component({
  selector: 'ctv-deals-autocomplete-chips',
  template: `
      <ctv-deals-autocomplete #pc
                                  (dealsSelected)="onItemSelected($event)"
                                  [formFieldClass]="formFieldClass"
                                  [required]="required"
                                  [label]="placeholder"
                                  [floatLabel]="floatLabel"
                                  [formFieldAppearance]="formFieldAppearance ? formFieldAppearance : ''">
      </ctv-deals-autocomplete>
      <mat-chip-list #chipList class="mt-n3" [ngClass]="[stacked ? 'mat-chip-list-stacked' : '', items.length > 0 ? 'mb-3' : '']" [hidden]="items.length < 1">
        <mat-basic-chip *ngFor="let item of items"
                        (removed)="remove(item)">
        <small class="fas fa-circle ml-n2 mr-2" ngClass="text-{{DealsStatusColorMap[item.status]}}"></small>
          {{item.name}}
          <span *csHasNetworkPermission>
            <span *ngIf="item.network" class="badge badge-primary ml-3">N</span>
          </span>
          <i class="fas fa-times-circle text-danger hand" matChipRemove></i>
        </mat-basic-chip>
      </mat-chip-list>
  `,
})
export class DealsAutocompleteChipsComponent implements OnInit {
  @ViewChild(DealsAutocompleteComponent, {static: true}) pc: DealsAutocompleteComponent;

  /** Pass clearFilterItems = new Subject<void>(); as Observable into it and then call clearFilterItems.next() to clear all the items*/
  @Input() clearItems: Observable<void>;
  @Input() public placeholder: string;
  @Input() public stacked: false;
  @Input() public dealIds: string[];
  @Input() public floatLabel: string;
  @Input() public formFieldClass: string;
  @Input() public formFieldAppearance: string;
  @Input() required = false;

  @Output() dealSelectionChange = new EventEmitter<Deals[]>();

  items: Deals[] = [];

  DealsStatusColorMap = ActiveInactiveArchivedColorMap;

  constructor(private service: PmpDealsService) {
  }

  ngOnInit(): void {
    if (this.dealIds && this.dealIds.length) {
      //On parent component reload if there is single preselected item, it will actually be passed as string instead of a list
      if (typeof this.dealIds === 'string') {
        this.dealIds = [this.dealIds];
      }
      //Fetch only preselected publishers
      this.service.getDealsList({ids: this.dealIds}).subscribe(deals => {
        deals.content.map(deal => {this.items.push(deal);});
        this.pc.updateFilteredDeals(this.items);
      });
    }
    this.clearItems?.subscribe(() => this.clearFilter());
  }

  /** Remove items that are not part of given network/s. */
  updatePublisherIdsChips(networks: string[]) {
    this.items = this.items.filter(x => networks.includes(x.network?.id));
    this.pc.updateFilteredDeals(this.items);
  }

  onItemSelected($event: Deals) {
    if ($event) {
      this.items.push($event);
      this.dealSelectionChange.emit(this.items);
      this.pc.resetInput();
      this.pc.updateFilteredDeals(this.items);
    }
  }

  remove(p: Deals) {
    this.items.splice(this.items.indexOf(p), 1);
    this.dealSelectionChange.emit(this.items);
    this.pc.updateFilteredDeals(this.items);
  }

  /** Clear all items from filter. */
  clearFilter(){
    this.items = [];
    this.pc.updateFilteredDeals(this.items);
  }

  disableFilter(disable: boolean) {
    if (disable) {
      this.pc.disable();
    }
    else {
      this.pc.enable();
    }
  }
}
